import { useEffect, useState } from "react";
import { Box, Slider, Typography, makeStyles } from "@material-ui/core";
import { ClearBadge, Color } from "@bonliva-crm/ui";
import locale from "@bonliva-crm/locale";
import { useFormField } from "@clientUtils";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { CollapsibleFavFilter } from "./_base/collapsible-fav-filter";

export interface AgeFilterData {
  from: number | null;
  to: number | null;
}

export type AgeFilterProps = FilterWithFavouriteProps;

export const AgeFilter = (props: AgeFilterProps) => {
  const classes = useStyles();

  const title = props.label ?? locale.AgeType;

  const { field, fieldState, setFieldValue } = useFormField<AgeFilterData | null>(
    props.name
  );

  const [value, setValue] = useState([
    field?.value?.from ?? 21,
    field?.value?.to ?? 90
  ] as [number, number]);

  useEffect(() => {
    setValue([field?.value?.from ?? 21, field?.value?.to ?? 90]);
  }, [field?.value?.from, field?.value?.to]);

  const handleFinalChange = (newValue: number[]) => {
    setFieldValue({ from: newValue[0], to: newValue[1] }, { shouldDirty: true });
  };

  const clear = () => {
    setFieldValue({ from: null, to: null }, { shouldDirty: true });
  };

  if (props.setFavorite) {
    return (
      <CollapsibleFavFilter
        title={title}
        favorite={props.favorite}
        onSetFavorite={props.setFavorite}
        isClearable={fieldState.isDirty}
        onClear={clear}
        isDirty={fieldState.isDirty}
        initialExpanded={fieldState.isDirty}
      >
        <Box pr={2} pt={2}>
          <Slider
            value={[value[0], value[1]]}
            onChange={(_, newValue) => setValue(newValue as [number, number])}
            onChangeCommitted={(_, newValue) => handleFinalChange(newValue as number[])}
            valueLabelDisplay="on"
            min={21}
            max={90}
            marks={[
              { value: 21, label: "21 år" },
              { value: 25, label: "" },
              { value: 66, label: "66 år" },
              { value: 90, label: "90 år" }
            ]}
            aria-labelledby="discrete-slider"
          />
        </Box>
      </CollapsibleFavFilter>
    );
  }

  return (
    <ClearBadge onClear={clear}>
      <div
        style={{
          border: `1px solid ${Color.LightGray}`,
          borderRadius: "4px",
          padding: "8px",
          paddingLeft: 16,
          paddingRight: 16,
          paddingTop: 16,
          minWidth: "300px"
        }}
      >
        <Typography variant="body1" style={{ color: Color.DetailsInput }}>
          {title}
        </Typography>

        <Box pl="10px" pr={1} pt={2}>
          <Slider
            value={[value[0], value[1]]}
            onChange={(_, newValue) => setValue(newValue as [number, number])}
            onChangeCommitted={(_, newValue) => handleFinalChange(newValue as number[])}
            valueLabelDisplay="on"
            min={21}
            max={90}
            marks={[{ value: 21 }, { value: 90 }]}
            aria-labelledby="discrete-slider"
            classes={{
              thumb: classes.miniSliderThumb
            }}
          />
        </Box>
      </div>
    </ClearBadge>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: theme.spacing(2)
  },

  miniSliderThumb: {
    height: 16,
    width: 16,
    borderWidth: 3,
    marginTop: -7,

    "& > span:first-child": {
      transform: "scale(1) translateY(-6px) translateX(-5px) !important"
    }
  }
}));
